
import vClickOutside from "v-click-outside";

export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },

  props: {
    title: {
      type: String,
    },

    dropList: {
      type: [Array, Object],
    },

    objName: {
      type: String,
    },

    directionIcon: {
      type: Boolean,
      default: true,
    },

    value: {
      type: [String, Number],
      default: null,
    },
  },

  data() {
    return {
      dropShow: false,
      selected: {},
    };
  },

  computed: {
    isSelected() {
      return Object.keys(this.selected).length;
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        if (newValue && this.dropList) {
          const item = this.dropList.find((i) => i.value === newValue);
          if (item) {
            this.selected = item;
          }
        }
      },
    },

    selected() {
      this.$emit("add", this.objName, this.selected);
    },
  },

  methods: {
    openDrop() {
      this.dropShow = !this.dropShow;
    },

    selectDrop(value) {
      this.dropShow = false;
      this.selected = value;
    },

    onClickOutside() {
      this.dropShow = false;
    },
  },
};
